import { create } from '@bufbuild/protobuf';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { tenantFailoverApi } from '@/api/tenantFailover.api';
import { ListRequestSchema } from '@/proto/agentplatform/httpv2/common_pb';
import {
  type CreateTenantFailoverRequest,
  type UpdateTenantFailoverRequest,
} from '@/proto/agentplatform/httpv2/tenant_failover_pb';

const QK_ROOT = ['tenant-failovers'] as const;
const QK = [...QK_ROOT, 'list'] as const;
const QK_GET = [...QK_ROOT, 'get'] as const;

export function useTenantFailovers(page = 1, pageSize = 10) {
  return useQuery({
    queryKey: [...QK, page, pageSize] as const,
    queryFn: () => tenantFailoverApi.list(create(ListRequestSchema, { page, pageSize })),
  });
}

export function useTenantFailover() {
  return useQuery({
    queryKey: QK_GET,
    queryFn: () => tenantFailoverApi.get(),
  });
}

export function useCreateTenantFailover() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateTenantFailoverRequest) => tenantFailoverApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK_ROOT });
    },
  });
}

export function useUpdateTenantFailover() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateTenantFailoverRequest) => tenantFailoverApi.update(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK_ROOT });
    },
  });
}

export function useDeleteTenantFailover() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => tenantFailoverApi.remove(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK_ROOT });
    },
  });
}
